import React from 'react'
import { useLocation } from 'react-router-dom'

function SuscriptionPlanIcon({ size = 28 }) {
  const location = useLocation()
  const isActive = location.pathname.startsWith('/freely-plan')
  const color = isActive ? '#FFFFFF' : '#8F9DAC'

  return (
    <svg width={size} height={size} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.33334 13.9998C2.33334 8.77511 2.33334 6.16274 3.95646 4.53962C5.57958 2.9165 8.19195 2.9165 13.4167 2.9165C18.6414 2.9165 21.2538 2.9165 22.8769 4.53962C24.5 6.16274 24.5 8.77511 24.5 13.9998C24.5 19.2245 24.5 21.8369 22.8769 23.4601C21.2538 25.0832 18.6414 25.0832 13.4167 25.0832C8.19195 25.0832 5.57958 25.0832 3.95646 23.4601C2.33334 21.8369 2.33334 19.2245 2.33334 13.9998Z'
        stroke={color}
        strokeWidth='1.8'
        strokeLinejoin='round'
      />
      <path
        d='M14.4244 9.00895L15.451 11.079C15.591 11.3672 15.9643 11.6436 16.2792 11.6965L18.1399 12.0082C19.3298 12.2082 19.6097 13.0785 18.7523 13.9371L17.3058 15.3956C17.0609 15.6426 16.9267 16.119 17.0025 16.46L17.4166 18.2654C17.7433 19.6946 16.9909 20.2473 15.7368 19.5004L13.9929 18.4595C13.6779 18.2714 13.1587 18.2714 12.838 18.4595L11.094 19.5004C9.8458 20.2473 9.08755 19.6886 9.41418 18.2654L9.8283 16.46C9.90414 16.119 9.76998 15.6426 9.525 15.3956L8.0785 13.9371C7.22693 13.0785 7.50106 12.2082 8.69093 12.0082L10.5516 11.6965C10.8607 11.6436 11.234 11.3672 11.374 11.079L12.4005 9.00895C12.9605 7.88569 13.8704 7.88569 14.4244 9.00895Z'
        stroke={color}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SuscriptionPlanIcon
